export class ToastManager {
    constructor() {
        this._injectStyles();
        this.container = document.getElementById('global-toast');
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.id = 'global-toast';
            this.container.className = 'toast';
            document.body.appendChild(this.container);
        }
        this.timeout = null;
    }

    _injectStyles() {
        if (document.getElementById('toast-styles')) return;
        const style = document.createElement('style');
        style.id = 'toast-styles';
        style.textContent = `
            .toast {
                position: fixed;
                bottom: 24px;
                left: 50%;
                transform: translateX(-50%) translateY(100px);
                background: #333;
                color: white;
                padding: 12px 24px;
                border-radius: 50px;
                font-size: 0.95rem;
                font-weight: 500;
                box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
                opacity: 0;
                transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                z-index: 10000;
                display: flex;
                align-items: center;
                gap: 10px;
                min-width: 200px;
                justify-content: center;
            }

            .toast.show {
                transform: translateX(-50%) translateY(0);
                opacity: 1;
            }

            .toast-success {
                background: linear-gradient(135deg, #56ab2f, #a8e063);
                color: #fff;
            }

            .toast-error {
                background: linear-gradient(135deg, #ff416c, #ff4b2b);
                color: #fff;
            }

            .toast-info {
                background: linear-gradient(135deg, #2b5876, #4e4376);
                color: #fff;
            }
        `;
        document.head.appendChild(style);
    }

    show(message, type = 'info', duration = 3000) {
        this.container.textContent = message;
        
        // Remove old classes but keep base 'toast'
        this.container.className = 'toast';
        this.container.classList.add(`toast-${type}`);
        
        // Force reflow
        this.container.offsetHeight;
        
        this.container.classList.add('show');
        
        if (this.timeout) clearTimeout(this.timeout);
        
        this.timeout = setTimeout(() => {
            this.container.classList.remove('show');
        }, duration);
    }
    
    error(message) {
        this.show(message, 'error');
    }
    
    success(message) {
        this.show(message, 'success');
    }

    info(message) {
        this.show(message, 'info');
    }
}

export const toast = new ToastManager();
